/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetPurchaserDto } from './GetPurchaserDto';
import {
    GetPurchaserDtoFromJSON,
    GetPurchaserDtoFromJSONTyped,
    GetPurchaserDtoToJSON,
} from './GetPurchaserDto';

/**
 * 
 * @export
 * @interface GetUmpMediaplanDto
 */
export interface GetUmpMediaplanDto {
    /**
     * 
     * @type {string}
     * @memberof GetUmpMediaplanDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetUmpMediaplanDto
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof GetUmpMediaplanDto
     */
    activeVersionUuid: string;
    /**
     * 
     * @type {Date}
     * @memberof GetUmpMediaplanDto
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetUmpMediaplanDto
     */
    endDate: Date;
    /**
     * 
     * @type {string}
     * @memberof GetUmpMediaplanDto
     */
    brandName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUmpMediaplanDto
     */
    purchaserUmp?: string;
    /**
     * 
     * @type {GetPurchaserDto}
     * @memberof GetUmpMediaplanDto
     */
    purchaser?: GetPurchaserDto;
    /**
     * 
     * @type {string}
     * @memberof GetUmpMediaplanDto
     */
    totalNetBudget?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUmpMediaplanDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUmpMediaplanDto
     */
    creatorName?: string;
    /**
     * 
     * @type {Date}
     * @memberof GetUmpMediaplanDto
     */
    creationTs?: Date;
    /**
     * 
     * @type {string}
     * @memberof GetUmpMediaplanDto
     */
    countryMarket?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GetUmpMediaplanDto
     */
    errors?: { [key: string]: string; };
}

/**
 * Check if a given object implements the GetUmpMediaplanDto interface.
 */
export function instanceOfGetUmpMediaplanDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "uid" in value;
    isInstance = isInstance && "activeVersionUuid" in value;
    isInstance = isInstance && "startDate" in value;
    isInstance = isInstance && "endDate" in value;

    return isInstance;
}

export function GetUmpMediaplanDtoFromJSON(json: any): GetUmpMediaplanDto {
    return GetUmpMediaplanDtoFromJSONTyped(json, false);
}

export function GetUmpMediaplanDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUmpMediaplanDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'uid': json['uid'],
        'activeVersionUuid': json['activeVersionUuid'],
        'startDate': (new Date(json['startDate'])),
        'endDate': (new Date(json['endDate'])),
        'brandName': !exists(json, 'brandName') ? undefined : json['brandName'],
        'purchaserUmp': !exists(json, 'purchaserUmp') ? undefined : json['purchaserUmp'],
        'purchaser': !exists(json, 'purchaser') ? undefined : GetPurchaserDtoFromJSON(json['purchaser']),
        'totalNetBudget': !exists(json, 'totalNetBudget') ? undefined : json['totalNetBudget'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'creatorName': !exists(json, 'creatorName') ? undefined : json['creatorName'],
        'creationTs': !exists(json, 'creationTs') ? undefined : (new Date(json['creationTs'])),
        'countryMarket': !exists(json, 'countryMarket') ? undefined : json['countryMarket'],
        'errors': !exists(json, 'errors') ? undefined : json['errors'],
    };
}

export function GetUmpMediaplanDtoToJSON(value?: GetUmpMediaplanDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'uid': value.uid,
        'activeVersionUuid': value.activeVersionUuid,
        'startDate': (value.startDate.toISOString()),
        'endDate': (value.endDate.toISOString()),
        'brandName': value.brandName,
        'purchaserUmp': value.purchaserUmp,
        'purchaser': GetPurchaserDtoToJSON(value.purchaser),
        'totalNetBudget': value.totalNetBudget,
        'status': value.status,
        'creatorName': value.creatorName,
        'creationTs': value.creationTs === undefined ? undefined : (value.creationTs.toISOString()),
        'countryMarket': value.countryMarket,
        'errors': value.errors,
    };
}

